export default __webpack_public_path__ + "static/media/phraseExample.32053e8d.gif";